import { render, staticRenderFns } from "./DocumentLogo.vue?vue&type=template&id=7b1dc6c6&scoped=true&"
import script from "./DocumentLogo.vue?vue&type=script&lang=ts&"
export * from "./DocumentLogo.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentLogo.vue?vue&type=style&index=0&id=7b1dc6c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1dc6c6",
  null
  
)

export default component.exports